@if (media.mediaType === MediaType.PowerPoint) {
	<div
		class="mediaCard"
		[class.active]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
		(click)="mediaClicked()"
	>
		<div class="mediaHeader">
			@if (pptxLoadingError) {
				<div class="fileLoadingError">
					<i class="fad fa-file-pdf fa-4x"></i>
				</div>
			}
			<sim-component-loading-container
				[isLoading]="!pptxLoaded && !pptxLoadingError"
				[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
				[loadingIcon]="'fad fa-file-powerpoint'"
			/>
			<sim-presentation-viewer
				[media]="media"
				(loaded)="pptxLoaded = $event"
				(loadingError)="pptxLoadingError = $event"
				[pageNum]="
					media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying
						? (mediaPlayer?.info?.currentMedia?.currentPosition ?? 1)
						: 1
				"
				[enableAutoPlay]="false"
				[autoPlayInterval]="5000"
				[width]="180"
				[height]="200"
			/>
			<div class="controlsContainer" [class.errorControls]="pptxLoadingError">
				<button
					mat-mini-fab
					color="accent"
					class="small previousBtn"
					(click)="previousPage(media.id)"
					appStopPropagation
					[disabled]="isPlayerUnusable() || !canNavigate('backward')"
				>
					<mat-icon fontSet="fas" fontIcon="fa-step-backward" inline />
				</button>
				<button
					mat-mini-fab
					color="accent"
					class="mediaPlayButton"
					[disabled]="mediaPlayer?.webSocket?.activityState === ActivityState.Inactive"
				>
					<sim-animated-material-icon
						[trigger]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
						[endIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-stop',
							themeColor: 'accent',
						}"
						[startIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-play',
							themeColor: 'white',
						}"
					/>
				</button>
				<button
					mat-mini-fab
					color="accent"
					class="small nextBtn"
					(click)="nextPage(media.id)"
					appStopPropagation
					[disabled]="isPlayerUnusable() || !canNavigate('forward')"
				>
					<mat-icon fontSet="fas" fontIcon="fa-step-forward" inline />
				</button>
			</div>
		</div>
		<div class="mediaText">
			<div class="title">{{ media.name }}</div>
			<div class="description">{{ media.fileName }}</div>
		</div>
	</div>
}
